<template>
  <div>
    <app-header title=""></app-header>

    <div class="container my-5">
      <div class="row mb-4">
        <div class="col d-flex align-items-center">
          <h2 class="mb-0">Project Dashboard</h2>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <multiselect
            :options="stageOptions"
            v-model="selectedStage"
            label="name"
            track-by="id"
            placeholder="Stage"
            :show-labels="false"
            :allow-empty="false"
            @select="loadResultsForStage"
          ></multiselect>
        </div>
      </div>

      <project-report-item
        v-for="report in reports"
        :key="report.id"
        :report="report"
        @show-data="showData"
      />

      <div v-if="!reports.length" class="card">
        <div class="card-body">
          <p class="text-center text-muted mb-0">No project reports for this stage.</p>
        </div>
      </div>
    </div>

    <report-data-modal ref="dataModal" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import ProjectReportItem from './projects/ProjectReportItem'
import ReportDataModal from './projects/ReportDataModal'

export default {
  components: {
    Multiselect,
    ProjectReportItem,
    ReportDataModal
  },

  data () {
    return {
      selectedStage: { id: 3, name: 'Stage 3' },
      stageOptions: [
        { id: 1, name: 'Stage 1' },
        { id: 2, name: 'Stage 2' },
        { id: 3, name: 'Stage 3' }
      ]
    }
  },

  computed: {
    ...mapState('projectReport', { reports: 'list' })
  },

  mounted () {
    this.loadResultsForStage(this.selectedStage)
  },

  methods: {
    ...mapActions('projectReport', { getReports: 'getList' }),

    loadResultsForStage (stage) {
      this.getReports({ stage: stage.id })
    },

    showData ({ title, rows }) {
      this.$refs.dataModal.open({ title, rows })
    }
  }
}
</script>
